import {
  ContentIsland,
  GraphicsCheckImage,
  GraphicsMoneyImage,
  GraphicsPumpkinImage,
  Grid,
  Typography,
} from '@razz-team/ui-web';
import { useTranslation } from 'react-i18next';
import { ApiThreeDS } from '../../../openapi';

export function ThreeDSStatus({ threeDS }: { threeDS: ApiThreeDS }) {
  const { t } = useTranslation();

  let image;
  switch (threeDS.state) {
    case 'APPROVED':
      image = <GraphicsCheckImage />;
      break;
    case 'DECLINED':
      image = <GraphicsPumpkinImage />;
      break;
    case 'PENDING':
      image = <GraphicsMoneyImage />;
      break;
  }

  let title;
  switch (threeDS.state) {
    case 'PENDING':
      title = t('Confirm Payment');
      break;
    case 'APPROVED':
      title = t('Payment Approved');
      break;
    case 'DECLINED':
      title = t('Payment Declined');
      break;
  }

  return (
    <ContentIsland>
      <Grid container alignItems="center" spacing={2} padding={4}>
        <Grid
          justifyContent="center"
          sx={{ '& img': { width: '100%', maxWidth: 256 } }}
          size={{
            xs: 12,
            sm: 6,
          }}
        >
          {image}
        </Grid>
        <Grid
          justifyContent="center"
          size={{
            xs: 12,
            sm: 6,
          }}
        >
          <Typography variant="h4">{title}</Typography>
        </Grid>
      </Grid>
    </ContentIsland>
  );
}
